module.exports = __webpack_public_path__ + "static/images/styles/images/pure-table/shine-right.08b8c8fc.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/pure-table/shine-right.png
// module id = 3683
// module chunks = 11